if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      isVariantLoading = false;
      currentVariantId = null;

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }
connectedCallback() {
    this.initializeProductSwapUtility();
    this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this)
    );

    this.initQuantityHandlers();
    this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

    // Get initial selected variant and store its ID
    const variant = this.getSelectedVariant(this);
    if (variant) {
        this.currentVariantId = variant.id;
        if (variant.options.length > 0) {
            let variantColor = this.removeAccents(variant.options[0]); // Assuming first option is color
            this.updateMedia(this, variant.featured_media?.id, variantColor);
        }
    }
}


      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        // Clear any previous error messages
        const productForm = this.productForm;
        if (productForm && typeof productForm.handleErrorMessage === 'function') {
          productForm.handleErrorMessage();
        }

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        // Mark that a variant change is in progress
        this.isVariantLoading = true;

        // Disable the submit button during fetch to prevent adding wrong variant
        const productForm = this.productForm;
        if (productForm && productForm.submitButton) {
          productForm.submitButton.setAttribute('disabled', 'disabled');
          productForm.submitButton.setAttribute('aria-disabled', 'true');

          // Force update the button text immediately using the translation
          const buttonTextElement = productForm.submitButton.querySelector('span') || productForm.submitButton;
          if (buttonTextElement) {
            buttonTextElement.textContent = window.variantStrings.unavailable;
          }
        }

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
              // Mark loading as complete even on error
              this.isVariantLoading = false;

              // Re-enable button on error only if productForm still exists
              const currentProductForm = this.productForm;
              if (currentProductForm && currentProductForm.submitButton) {
                currentProductForm.submitButton.removeAttribute('disabled');
                currentProductForm.submitButton.removeAttribute('aria-disabled');
                if (currentProductForm.submitButtonText) {
                  currentProductForm.submitButtonText.textContent = window.variantStrings.addToCart;
                }
              }
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }
// Add this helper method to remove accents
removeAccents(str) {
    if (!str) return str;
    
    // Map of accented characters to their non-accented equivalents
    const accentMap = {
        'á': 'a', 'à': 'a', 'â': 'a', 'ä': 'a', 'ã': 'a', 'å': 'a',
        'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
        'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
        'ó': 'o', 'ò': 'o', 'ô': 'o', 'ö': 'o', 'õ': 'o',
        'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
        'ñ': 'n', 'ç': 'c'
    };
    
    // Replace accented characters
    return str.split('').map(char => {
        const lowerChar = char.toLowerCase();
        return accentMap[lowerChar] || char;
    }).join('').toLowerCase();
}
handleUpdateProductInfo(productUrl) {
    return (html) => {
        const variant = this.getSelectedVariant(html);
        this.pickupAvailability?.update(variant);
        this.updateOptionValues(html);
        this.updateURL(productUrl, variant?.id);

        // Update variant inputs FIRST before doing anything else
        this.updateVariantInputs(variant?.id);

        // Store the current variant ID and mark loading as complete
        this.currentVariantId = variant?.id || null;
        this.isVariantLoading = false;

        if (!variant) {
            this.setUnavailable();
            return;
        }

        // Get color from options array (first element is color)
        let variantColor = null;
        if (variant.options && variant.options.length > 0) {
            variantColor = variant.options[0]; // "Gris" in your example
            // Remove accents using a replacement map
            variantColor = this.removeAccents(variantColor);
        }

        // Pass the color to updateMedia
        this.updateMedia(html, variant?.featured_media?.id, variantColor);



          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          // Only enable button after variant ID has been updated
          const productForm = this.productForm;
          if (productForm && typeof productForm.toggleSubmitButton === 'function') {
            const submitButtonInHtml = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
            const shouldDisable = submitButtonInHtml?.hasAttribute('disabled') ?? false;
            const buttonText = shouldDisable ? window.variantStrings.soldOut : null;
            productForm.toggleSubmitButton(shouldDisable, buttonText);
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        const productForm = this.productForm;
        if (productForm && typeof productForm.toggleSubmitButton === 'function') {
          productForm.toggleSubmitButton(true, window.variantStrings.unavailable);
        }

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }


updateThumbnails(variantColor) {
    if (!variantColor) return;
    
    const thumbnailsContainer = document.getElementById(`Slider-Thumbnails-${this.dataset.section}`);
    if (!thumbnailsContainer) return;

    // Normalize color for comparison
    const normalizedColor = this.removeAccents(variantColor.toLowerCase());

    // Get all thumbnail items
    const allThumbnails = Array.from(thumbnailsContainer.querySelectorAll('.thumbnail-list__item'));

    // Function to check if an image matches the selected color
    const filterByVariantColor = (thumbnail) => {
        const imgElement = thumbnail.querySelector('img');
        if (!imgElement) return false;

        const imgSrc = imgElement.getAttribute('src') || '';
        const imgAlt = imgElement.getAttribute('alt') || '';

        return (
            imgSrc.toLowerCase().includes(normalizedColor) ||
            imgAlt.toLowerCase().includes(normalizedColor)
        );
    };

    // Separate matching and non-matching thumbnails
    const matchingThumbnails = allThumbnails.filter(filterByVariantColor);
    const nonMatchingThumbnails = allThumbnails.filter((thumb) => !filterByVariantColor(thumb));

    // Hide non-matching thumbnails
    nonMatchingThumbnails.forEach((thumb) => (thumb.style.display = 'none'));

    // Ensure matching thumbnails are visible
    matchingThumbnails.forEach((thumb) => (thumb.style.display = ''));

    // Ensure the correct ordering in the slider
    matchingThumbnails.forEach((thumb) => thumbnailsContainer.appendChild(thumb));

    // If no matching thumbnails found, revert to all
    if (matchingThumbnails.length === 0) {
        allThumbnails.forEach((thumb) => (thumb.style.display = ''));
    }

    // Set the first matching thumbnail as active
    const firstVisibleThumbnail = matchingThumbnails[0] || allThumbnails[0];
    if (firstVisibleThumbnail) {
        firstVisibleThumbnail.querySelector('button').setAttribute('aria-current', 'true');
    }
}

      
updateMedia(html, variantFeaturedMediaId, variantColor) {
    if (!variantFeaturedMediaId) return;
    this.updateThumbnails(variantColor); 
    const mediaGallerySource = this.querySelector('media-gallery ul');
    const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
    
    // Filter function to match images by variant color
    const filterByVariant = (item) => {
        if (!variantColor) return true; // If no color specified, show all

        // Check if image src or alt contains the variant color name
        const imgElement = item.querySelector('img');
        if (!imgElement) return true;

        const imgSrc = imgElement.getAttribute('src') || '';
        const imgAlt = imgElement.getAttribute('alt') || '';
        const normalizedColor = variantColor.toLowerCase();

        // Check if src or alt contains the color name
        return imgSrc.toLowerCase().includes(normalizedColor) ||
               imgAlt.toLowerCase().includes(normalizedColor);
    };
    
    const refreshSourceData = () => {
        if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
        
        // Get all media items
        const allMediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
        
        // Filter items by variant color
        const mediaGallerySourceItems = allMediaGallerySourceItems.filter(filterByVariant);
        // Hide items that don't match the variant - use visibility for better performance
        allMediaGallerySourceItems.forEach(item => {
            const shouldShow = filterByVariant(item);
            if (shouldShow) {
                item.removeAttribute('hidden');
                item.style.visibility = 'visible';
            } else {
                item.setAttribute('hidden', '');
                item.style.visibility = 'hidden';
            }
        });

        const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
        const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
        );

        return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
        let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

        // Filter destination items by variant color
        const allMediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
        );
        const mediaGalleryDestinationItems = allMediaGalleryDestinationItems.filter(filterByVariant);

        const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
        let shouldRefresh = false;


        // add items from new data not present in DOM
        for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
                mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
                shouldRefresh = true;
            }
        }

        // remove items from DOM not present in new data
        for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
                mediaGallerySourceItems[i].remove();
                shouldRefresh = true;
            }
        }
        
        // refresh
        if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

        
        // if media galleries don't match, sort to match new data order
        mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
            if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                    sourceData.item,
                    mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
                );
                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

            }
        });
    }

    // set featured media as active in the media gallery
    this.querySelector(`media-gallery`)?.setActiveMedia?.(
        `${this.dataset.section}-${variantFeaturedMediaId}`,
        true
    );
    
    // update media modal
    const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
}

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
